import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import moment from 'moment';
import { environment } from 'src/environments/environment';

import { Pageable } from 'src/app/shared/model/pageable.model';
import { GuiaMedicaSearchParameter } from 'src/app/shared/model/search/guia-medica-search-parameters.model';
import { Observable } from 'rxjs';
import { GuiaMedica } from 'src/app/shared/model/guia-medica.model';
import { RelatorioSearchParameter } from 'src/app/shared/model/search/relatorio-search-parameters.model';

@Injectable()
export class AtendimentoService {

  urlBaseApi: string;
  urlGeradorXlsx: string;

  constructor(private http: HttpClient) {
    this.urlBaseApi = `${environment.mouraAmmServerURL}/guia`;
    this.urlGeradorXlsx = `${environment.mouraAmmServerURL}/relatorio`;
  }

  listarGuias(pageable: Pageable, filtros: GuiaMedicaSearchParameter): Observable<any> {
    const params = this.montarHttpParams(pageable, filtros);
    return this.http.get(`${this.urlBaseApi}`, { params });
  }

  // Método responsável por buscar a lista de atendimentos para montar o relatório do HCM
  dadosRelatorio(filtros: RelatorioSearchParameter): Observable<any> {
    let params = this.montarParametrosRequisicaoRelatorio(filtros);
    return this.http.get(`${this.urlBaseApi}/relatorio`, { params });
  }

  // Método responsável por buscar a lista de atendimentos para montar o relatório do HCM
  gerarRelatorioSinteticoHCM(filtros: RelatorioSearchParameter): Observable<any> {
    let params = this.montarParametrosRequisicaoRelatorio(filtros);
    return this.http.get(`${this.urlGeradorXlsx}/sintetico`,  { params: params, responseType: 'blob' });
  }

  gerarRelatorioAnalitico(filtros: RelatorioSearchParameter): Observable<any> {
    let params = this.montarParametrosRequisicaoRelatorio(filtros);
    return this.http.get(`${this.urlGeradorXlsx}/analitico`,  { params: params, responseType: 'blob' });
  }

  gerarRelatorioADP(filtros: RelatorioSearchParameter): Observable<any> {
    let params = this.montarParametrosRequisicaoRelatorio(filtros);
    return this.http.get(`${this.urlGeradorXlsx}/adp`,  { params: params, responseType: 'blob' });
  }

  cadastrar(guiaMedica: GuiaMedica): Observable<any> {
    return this.http.post<GuiaMedica>(`${this.urlBaseApi}`, guiaMedica);
  }

  alterar(guiaMedica: GuiaMedica): Observable<any> {
    return this.http.put<GuiaMedica>(`${this.urlBaseApi}/${guiaMedica.id}`, guiaMedica);
  }

  buscar(guiaMedicaId: number): Observable<any> {
    return this.http.get(`${this.urlBaseApi}/${guiaMedicaId}`);
  }

  excluir(guiaMedicaId: number): Observable<any> {
    return this.http.delete(`${this.urlBaseApi}/${guiaMedicaId}`);
  }

  consultarDependentes(identificadorTitular: string): Observable<any> {
    return this.http.get(`${this.urlBaseApi}/consultar-dependentes/${identificadorTitular}`);
  }

  finalizarAtendimento(guiaMedicaId: number): Observable<any> {
    return this.http.put(`${this.urlBaseApi}/${guiaMedicaId}/finalizar-atendimento`, null);
  }

  private montarParametrosRequisicaoRelatorio(filtros: RelatorioSearchParameter) {
    let params = new HttpParams();

    if (filtros.id) {
      params = params.set('id', filtros.id.toString());
    }

    if (filtros.beneficiado) {
      params = params.set('beneficiado', filtros.beneficiado);
    }

    if (filtros.cpf) {
      params = params.set('cpf', filtros.cpf);
    }

    if (filtros.prestador) {
      params = params.set('prestador', filtros.prestador);
    }

    if (filtros.dataInicio) {
      params = params.set('dataInicio', moment(filtros.dataInicio).format('YYYY-MM-DDT00:00:00Z'));
    }

    if (filtros.dataFim) {
      params = params.set('dataFim', moment(filtros.dataFim).format('YYYY-MM-DDT23:59:59Z'));
    }

    return params;
  }

  /**
   * Método responsável por montar os parâmetro que serão enviados na requisição
   * @param pageable objeto com os dados da paginação.
   * @param filtros objeto com combinação dos filtros selecionados no componente.
   */
  private montarHttpParams(pageable: Pageable, filtros: GuiaMedicaSearchParameter): HttpParams {
    const pageAtual = pageable.page - 1;

    let params = new HttpParams();
    params = params.set('page', pageAtual.toString());
    params = params.set('size', pageable.size.toString());
    params = params.set('sort', 'id,desc');

    if (filtros.id) {
      params = params.set('id', filtros.id.toString());
    }

    if (filtros.beneficiado) {
      params = params.set('beneficiado', filtros.beneficiado);
    }

    if (filtros.cpf) {
      params = params.set('cpf', filtros.cpf);
    }

    if (filtros.dataInicio) {
      params = params.set('dataInicio', moment(filtros.dataInicio).format('YYYY-MM-DDT00:00:00Z'));
    }

    if (filtros.dataFim) {
      params = params.set('dataFim', moment(filtros.dataFim).format('YYYY-MM-DDT23:59:59Z'));
    }

    return params;
  }
}
